
/* injects from baggage-loader */

'use strict';

import fileManagementTemplate from '!!file-loader?name=templates/[name].[ext]!./fileManagement.html';

/**
* Function that register the all routes for the view fileManagement module.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @param {any} routerHelper
*/
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	* Route definition of the view fileManagement page.
	*/
	const indexNav = 4;
	const fileManagementRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: fileManagementTemplate,
			controller: 'FileManagementController',
			controllerAs: 'fileManagementvm',
			resolve: {
				fileManagement: fileManagementLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: true,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	}

	routerHelper.configureStates([fileManagementRoute]);
}

/**
* Function for the lazyLoading configuration in the view fileManagement route.
*
* @param {any} $q
* @param {any} $ocLazyLoad
* @returns
*/
function fileManagementLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const fileManagementModule = require('./fileManagement.module');

		$ocLazyLoad.load({
			name: fileManagementModule.default.name,
		});

		deferred.resolve(fileManagementModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('fileManagement.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/auth/management/fileManagement/fileManagement.routes.js